import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import SocialCard from './SocialCard';
import { SOCIAL_MEDIA_TYPE } from './constants';
import { ICONS } from '../../../icons';

import scss from './BrandSocials.module.scss';

function BrandSocials({ chosenDomain }) {
  const { t } = useTranslation('sonar');

  const mappedLogos = useMemo(
    () => ({
      [SOCIAL_MEDIA_TYPE.FACEBOOK]: ICONS.FacebookLogo,
      [SOCIAL_MEDIA_TYPE.INSTAGRAM]: ICONS.InstagramLogo,
      [SOCIAL_MEDIA_TYPE.TWITTER]: ICONS.TwitterLogo,
      [SOCIAL_MEDIA_TYPE.YOUTUBE]: ICONS.YouTubeLogo,
      [SOCIAL_MEDIA_TYPE.TIKTOK]: ICONS.TikTokLogo,
      [SOCIAL_MEDIA_TYPE.LINKEDIN]: ICONS.LinkedInLogo,
      [SOCIAL_MEDIA_TYPE.TRUSTPILOT]: ICONS.TrustpillotLogo,
    }),
    [],
  );

  const mappedCards = useMemo(() => {
    return Object.keys(chosenDomain.socialCalculations).flatMap((key) =>
      chosenDomain.socialCalculations[key].map((mediaData) => ({
        type: key,
        logo: mappedLogos[key],
        ...mediaData,
      })),
    );
  }, [chosenDomain.socialCalculations, mappedLogos]);

  return (
    <div className={scss.sectionWrapper}>
      <h4 className={scss.sectionTitle}>{t('socials')}</h4>

      <div className={scss.socialsGrid}>
        {mappedCards.map((data, index) => (
          <SocialCard key={index} data={data} />
        ))}
      </div>
    </div>
  );
}

export default BrandSocials;
